import { render, staticRenderFns } from "./DreamPDF2.vue?vue&type=template&id=3a14dbe2&scoped=true"
import script from "./DreamPDF2.vue?vue&type=script&lang=js"
export * from "./DreamPDF2.vue?vue&type=script&lang=js"
import style0 from "./DreamPDF2.vue?vue&type=style&index=0&id=3a14dbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a14dbe2",
  null
  
)

export default component.exports